import { useNextCatalogs } from 'hooks';

import CycleCatalog from '../components/CycleCatalog/CycleCatalog';

export const NextCycle = () => {
  const { data: nextCatalog, isLoading, isSuccess } = useNextCatalogs();

  return (
    <CycleCatalog
      isNextCycle
      isLoading={isLoading}
      isSuccess={isSuccess}
      catalogs={nextCatalog}
      pageTitle='Próximo Ciclo'
      description='Consulte os catálogos do próximo ciclo para programar a sua revenda com antecedência. Somente compartilhe a partir da data válida.'
    />
  );
};
